<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
            <div class="text-xl font-bold">
                <label-component label="Scopes" postfix="(scopes)" />
            </div>

            <div class="overflow-x-auto w-full h-96">
                <table class="table w-full">
                    <!-- head -->
                    <thead>
                        <tr>
                            <th></th>

                            <th>Scope</th>
                            <th>Claims</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- rows -->
                        <tr v-for="(scope, index) of scopesStore.getScopes" v-bind:key="index">
                            <th>
                                <label>
                                    <input
                                        type="checkbox"
                                        class="checkbox"
                                        :checked="hasScope(scope.identifier)"
                                        @change="add(scope.identifier)"
                                    />
                                </label>
                            </th>

                            <td>
                                {{ scope.name }}
                            </td>

                            <td>
                                {{ scope.claims.join(', ') }}
                            </td>
                        </tr>
                    </tbody>

                    <!-- foot -->
                    <tfoot>
                        <tr>
                            <th></th>
                            <th>Scopes</th>
                            <th>Claims</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div v-if="isMode('update')" class="self-end">
            <button-component fa-icon="fa-regular fa-floppy-disk" @click="$emit('save')"></button-component>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useScopesStore } from '@/stores/scopes';
import { useApplicationStore } from '@/stores/application';
import ButtonComponent from '@/components/ButtonComponent';
import LabelComponent from '@/components/LabelComponent';

export default {
    name: 'ScopesTab',
    components: { LabelComponent, ButtonComponent },
    props: ['modelValue', 'mode'],
    data() {
        return {
            client: undefined
        };
    },
    created() {
        this.client = this.modelValue;
        this.scopesStore.fetchScopes();
    },
    computed: {
        ...mapStores(useScopesStore, useApplicationStore)
    },
    methods: {
        hasScope(scope) {
            return this.client.scopes.includes(scope);
        },
        add(scope) {
            const index = this.client.scopes.findIndex((clientScope) => clientScope === scope);

            if (index !== -1) {
                this.client.scopes.splice(index, 1);
            } else {
                this.client.scopes.push(scope);
            }

            this.$emit('update:modelValue', this.client);
        },
        isMode(mode) {
            return this.mode === mode;
        }
    }
};
</script>

<style scoped></style>
